<template>
  <!-- <de-layout-content></de-layout-content> -->
  <div class="txtMsg">
    <el-form :model="queryParams" ref="queryForm" :inline="true" size="small" class="ant-advanced-search-form">
      <el-form-item label="发送时间" prop="time">
        <el-date-picker v-model="queryParams.time" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']" range-separator="-" start-placeholder="起始时间" end-placeholder="结束时间"
          @change="$forceUpdate()"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
        <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" element-loading-text="加载中" :data="list">
      <el-table-column label="序号" align="center" type="index" />
      <el-table-column label="消息内容" align="left" prop="content">
        <template slot-scope="scope">
          <span class="txt-hide2">{{ scope.row.content }}</span>
        </template>
      </el-table-column>
      <el-table-column label="接收人" align="center" prop="accepterName" />
      <el-table-column label="接收账号" align="center" prop="accepterPhone" />
      <el-table-column label="发送时间" align="center" prop="createTime" width="200">
        <template slot-scope="scope">
          {{
          scope.row.createTime
          ? moment(scope.row.createTime).format("yyyy-MM-DD HH:mm:ss")
          : ""
          }}
        </template>
      </el-table-column>
    </el-table>

    <pagination :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
      @pagination="_getList" />
  </div>
</template>

<script>
import moment from "moment";
import * as API_System from "@/api/train/system";


export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        time: [],
        startTime: "",
        endTime: "",
      },
      list: [],
      total: 0,
      loading: false,
    };
  },
  components: {
  },
  methods: {
    moment,
    handleQuery() {
      this.queryParams.startTime = this.queryParams.time.length
        ? moment(this.queryParams.time[0]).valueOf()
        : null;
      this.queryParams.endTime = this.queryParams.time.length
        ? moment(this.queryParams.time[1]).valueOf()
        : null;
      console.log(this.queryParams);
      this.queryParams.pageNum = 1;
      this._getList();
    },
    resetQuery() {
      this.queryParams.startTime = "";
      this.queryParams.endTime = "";
      this.$refs["queryForm"].resetFields();
      this.handleQuery();
    },
    _getList() {
      this.loading = true;
      API_System.sysMsgList(this.queryParams).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.total = res.data.total;
          this.list = res.data.list;
          setTimeout(() => {
            this.loading = false;
          }, 500);
        }
      });
    },
  },
  created() {
    this._getList();
  },
};
</script>
<style lang="less" scoped>
@import "/src/styles/common/common.less";
</style>
